import ControlBar from "@/components/ControlBar/ControlBar";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";
import useDashboardStore from "@/state/dashboard";
import { useDashboardInitialization } from "@/config/config";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
const { VITE_PRODUCTION_BASE } = import.meta.env;

const ExternalContainer = () => {
  const ready = useDashboardInitialization();
  const [router, setRouter] = useState(null);
  const dashboards = useDashboardStore((state) => state.dashboards);

  const Root = () => {
    return (
      <div className="external-container">
        <ControlBar />
        <div className="external-dashboard-content">
          <Outlet />
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (dashboards.length > 0) {
      const router = createBrowserRouter([
        {
          path: VITE_PRODUCTION_BASE,
          element: <Root />,
          children: dashboards.map((dashboard) => {
            const Dashboard = dashboard.dashboard;
            return {
              path: `${VITE_PRODUCTION_BASE}${dashboard.path}`,
              element: <Dashboard />
            };
          })
        }
      ]);
      setRouter(router);
    }
  }, [dashboards.length]);

  return ready ? router && <RouterProvider router={router} /> : <FullScreenLoader open={!ready} />;
};
export default ExternalContainer;
